import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-user-avatar",
  "use": "foquz-icon-vue-user-avatar-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-user-avatar\"><rect width=\"30\" height=\"30\" rx=\"6\" fill=\"#E0E4EB\" /><path d=\"M22 23v-1.5c0-1.933-1.55-3.5-3.462-3.5h-8.077C8.55 18 7 19.567 7 21.5V23m11-13a3 3 0 11-6 0 3 3 0 016 0z\" stroke=\"#679\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol